import { RouteObject } from "react-router";
import Authenticated from "src/components/Authenticated";
import ExtendedSidebarLayout from "src/layouts/ExtendedSidebarLayout";
import CollapsedSidebarLayout from "src/layouts/CollapsedSidebarLayout";
import { TcsCuRoutes, TcsPastRfpRoutes, TcsRFPRoutes, TcsTemplateRfpRoutes } from "./paths";
import Callback from "src/content/pages/Callback";
import { lazy, Suspense } from "react";
import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const cuRoutes: RouteObject[] = [
  {
    path: "",
    element: (
      <Authenticated>
        <ExtendedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "/",
        children: TcsCuRoutes,
      },
    ],
  },
  {
    path: "",
    element: (
      <Authenticated>
        <CollapsedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "corporate/cr",
        children: TcsRFPRoutes,
      },
    ],
  },
  {
    path: "",
    element: (
      <Authenticated>
        <CollapsedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "corporate/template-bank/cr",
        // element: <TemplatePreview />,
        children: TcsTemplateRfpRoutes,
      },
    ],
  },
  {
    path: "",
    element: (
      <Authenticated>
        <CollapsedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: "corporate/past-cr/",
        // element: <TemplatePreview />,
        children: TcsPastRfpRoutes,
      },
    ],
  },
  {
    path: "",
    element: (
      <Authenticated>
        <CollapsedSidebarLayout />
      </Authenticated>
    ),
  },
  {
    path: "",
    element: (
      <Authenticated>
        <CollapsedSidebarLayout />
      </Authenticated>
    ),
  },
  {
    path: "callback",
    element: <Callback />,
  },
];

export default cuRoutes;
